import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

// fields: [{k, label, type?: text|number|date|time|textarea|select, options?: [{value,label}], full?}]
export const FormDialog = ({ open, onOpenChange, title, fields, value, onChange, onSubmit, testid, children }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card max-w-2xl max-h-[90vh] overflow-y-auto" data-testid={testid}>
        <DialogHeader><DialogTitle className="font-heading">{title}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {fields.map((f) => (
            <div key={f.k} className={f.full || f.type === "textarea" ? "sm:col-span-2" : ""}>
              <Label className="text-xs font-semibold">{f.label}</Label>
              {f.type === "textarea" ? (
                <Textarea data-testid={`field-${f.k}`} value={value[f.k] ?? ""} onChange={(e) => set(f.k, e.target.value)} className="mt-1 bg-background" />
              ) : f.type === "select" ? (
                <select data-testid={`field-${f.k}`} value={value[f.k] ?? ""} onChange={(e) => set(f.k, e.target.value)}
                  className="mt-1 h-9 w-full rounded-md border border-input bg-background px-2 text-sm">
                  {f.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              ) : (
                <Input data-testid={`field-${f.k}`} type={f.type || "text"} value={value[f.k] ?? ""}
                  onChange={(e) => set(f.k, f.type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)}
                  className="mt-1 bg-background" />
              )}
            </div>
          ))}
        </div>
        {children}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Avbryt</Button>
          <Button data-testid={`${testid}-save`} onClick={onSubmit}>Lagre</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
